/// <reference types="vite/client" />
import { useApplication } from 'merchant-api/unified';
import { LDR } from 'merchant-api/types';
import { queryOptions, useQuery, UseQueryResult } from '@tanstack/react-query';
import { spiceroad } from '..';

export interface useLDRProps {
  ldrLoading: boolean;
  loanDocRequest: LDR[] | null | undefined;
  ldrError: any;
  hasBankRequest: boolean;
  hasClosedBankRequest: boolean;
  hasOpenBankRequest: boolean;
  LDRType?: string;
  query: UseQueryResult<LDR[]>;
}

const getLDRData = (opportunityId: string) =>
  spiceroad
    .get<LDR[]>(`/v1/ldr/${opportunityId}`, {
      validateStatus: (status) => status === 200 || status === 404,
    })
    .then((res) => (res.status === 404 ? [] : res.data));

export const getLDROpts = (opportunityId: string) =>
  queryOptions<LDR[]>({
    queryKey: ['ldr', opportunityId],
    queryFn: () => getLDRData(opportunityId),
    refetchOnMount: true,
    retry: false,
  });

export function getLDR(strictStatus: boolean = false): useLDRProps {
  const { opportunityId, isLoadingApplication, isErrorApplication } = useApplication(['APPROVED'], strictStatus);
  const query = useQuery({
    ...getLDROpts(opportunityId!),
    enabled: !!opportunityId,
  });
  const { data, error, isLoading } = query;
  return {
    hasOpenBankRequest:
      data?.some((r) => r.issueType === 'No bank statements' && r.status === 'REQUESTED') ?? false,
    hasClosedBankRequest:
      data?.some((r) => r.issueType === 'No bank statements' && r.status !== 'REQUESTED') ?? false,
    hasBankRequest: data?.some((r) => r.issueType === 'No bank statements') ?? false,
    LDRType: data?.filter((ldr) => ldr.status === 'REQUESTED')[0]?.issueType,
    loanDocRequest: data,
    ldrError: error || isErrorApplication,
    ldrLoading: isLoading || isLoadingApplication,
    query,
  };
}

export default getLDR;
